<template>
    <div style="font-family: 'Courier New', Courier, monospace;">
    <div class="text-center">
        <span v-if="userData.logo!=0"><img :src="getFiles(userData.logo)" height="40"/></span>
        <span v-else><img src="@/assets/images/logo.png" height="40"/></span><br>
        <h4 style="color:black" class="text-uppercase">{{ userData.business }}</h4>
        <span style="color:black;font-size:13px">Location : {{ userData.location }}</span><br>
        <span style="color:black;font-size:13px">Telephone : {{ userData.contact }}</span><br><br>
        <span style="color: black;font-size:13px" class="text-decoration-underline"><b> PAYMENT RECIEPT</b></span><br>
        <span style="color:black;font-size:13px"> Reciept No : {{ this.$route.query.id }}</span><br>
        <span style="color:black;font-size:13px"> Date : {{ addedon }}</span>
    </div>
        <table class="table table-sm mt-1" style="color: black;" density="compact">
            <thead><tr><th>Qty</th><th>Item Name</th><th>Price</th></tr></thead>
            <tbody>
            <tr v-for="item in ordersbyid" :key="item.id">
                <td>{{ item.quantity }} {{ item.unit }} </td>
                <td>{{ item.product }}</td>
                <td>{{ commas(item.price) }}</td>
                </tr>
            </tbody>
        </table>
    <div class="mt-2 text-center">
        <span style="color: black;font-size:14px"><b> AMOUNT PAID : {{commas(amount)}}</b></span><br>
        <h6 style="color: black;" class="my-4 text-center">Signature : .........................</h6>
        <p style="color:black;font-size:13px">Printed by : {{ userData.username }}
        <br>Thanks for Supporting Us. <br> Printed Via Afrimed Software
        <br> www.afrimedsolutions.com </p>
    </div>
    </div>
</template>

<script>
import appConfig from "@/app.config";
import axios from "axios";
export default {
    page: {
      title: "Print Reciept",
      meta: [{ name: "description", content: appConfig.description,},],
    },
    data() {
        return {
            userData: JSON.parse(localStorage.getItem("user")),
            ordersbyid:[],
            addedon:'',
            amount:'',
        };
    },
    methods: {
        async showticket(){
        this.transaction_id=this.$route.query.id;
        let url = `/orderbyid/${this.transaction_id}`;
        await axios.get(url).then((response) => {
          this.ordersbyid = response.data.orders;
          });
      },
      async showOrder(){
        this.transaction_id=this.$route.query.id;
        let url = `/showorderbyid/${this.transaction_id}`;
        await axios.get(url).then((response) => {
        this.addedon=response.data.order[0].added_on;
        this.amount=response.data.order[0].amount;
        });
        },
    
        getFiles(name){
        let url = axios.defaults.baseURL;
        let imagelink = (url).slice(0,-3)+"logos/"+name;
        return imagelink;
        },
      commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    },
    mounted() {
        this.showticket();
        this.showOrder();
        setTimeout(() => {
          window.print();
          window.onafterprint=this.$router.go(-1);
        }, 1800);
    },
}
</script>